const menuEcommerce = `
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17">
      <g fill="none" fill-rule="evenodd" transform="translate(0 -2)">
        <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 2.25)">
          <circle cx="14.25" cy="14.25" r="1.125"/>
          <circle cx="6" cy="14.25" r="1.125"/>
          <polyline points=".375 .375 3 .375 6 13.125 14.25 13.125"/>
          <polyline points="5.647 11.625 15.375 11.625 17.625 4.875 4.059 4.875"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuEcommerce;
